import { render, staticRenderFns } from "./how-many-studs.vue?vue&type=template&id=baed5660&"
import script from "./how-many-studs.vue?vue&type=script&lang=js&"
export * from "./how-many-studs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports